import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import DefaultImage from '../../assets/images/Default-Actor-Image.png';
import './../../assets/styles/constants.css';
import './../../assets/styles/fonts.css';
import './ActorInfo.css';

const ActorInfo = props => {
  const {
    name,
    pictureUrl,
    showsCount,
    moviesCount,
    externalLinks,
    fanFavoriteVotes
  } = props;
  return (
    <div className="actor-info-root">
      <img
        className="actor-info__headshot"
        src={pictureUrl || DefaultImage}
        alt={name}
      />
      <div className="actor-info__panel">
        <h1 className="actor-info__title">{name}</h1>
        <div className="actor-info__details">
          <div className="actor-info__title-count-container">
            <div className="actor-info__title-count">{showsCount} Shows</div>
            {showsCount > 0 && moviesCount > 0 && (
              <span className="actor-info__title-separator"></span>
            )}
            {moviesCount > 0 && (
              <div className="actor-info__title-count">
                {moviesCount} Movies
              </div>
            )}
          </div>
          <ul className="actor-info__external-links">
            {externalLinks.map((l, idx) => (
              <li key={`index_${idx + 1}`}>
                <a href={l.url}>{l.text}</a>
                {idx !== externalLinks.length - 1 && (
                  <span className="actor-info__external-links__separator">
                    •
                  </span>
                )}
              </li>
            ))}
          </ul>
        </div>
        <div className="actor-report__fan-favorite-votes-wrapper">
          <div className="actor-report__fan-favorite-votes-content">
            <div className="actor-report__fan-favorite-votes-arrow" />
            <div className="actor-report__fan-favorite-votes-count">
              {get(fanFavoriteVotes, [0, 'value'], '')}
            </div>
            <div className="actor-report__fan-favorite-votes-label">
              {get(fanFavoriteVotes, [0, 'label'], '')}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ActorInfo.propTypes = {
  name: PropTypes.string.isRequired,
  pictureUrl: PropTypes.string.isRequired,
  externalLinks: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      url: PropTypes.string
    })
  ),
  showsCount: PropTypes.number,
  moviesCount: PropTypes.number,
  fanFavoriteVotes: PropTypes.shape({}).isRequired
};

ActorInfo.defaultProps = {
  externalLinks: [],
  showsCount: 0,
  moviesCount: 0
};

export default ActorInfo;
